// extracted by mini-css-extract-plugin
export default {"badgeSuccessClass":"styles_badgeSuccessClass__-0eD9","badgeSecondaryClass":"styles_badgeSecondaryClass__I9f8l"};